import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/htl-part/src/environments/environment";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Helicopter } from "../shared/models/helicopter.model";
import { HtlService } from "../htl/htl.service";

enum EndpointRoutes {
    GET_HELICOPTERS = "helicopter/get",
    GET_HELICOPTER_ATTRIBUTES = "helicopter/attributes/get",
}

@Injectable({
    providedIn: "root",
})
export class HelicoptersService {
    constructor(
        private _http: HttpClient,
        private _htlService: HtlService,
    ) {}

    getHelicopters(organizationId: number): Observable<Helicopter[]> {
        let params = new HttpParams();
        params = params.append("organizationId", organizationId.toString());
        return this._http.get<Helicopter[]>(environment.serverUrl + EndpointRoutes.GET_HELICOPTERS, { params }).pipe(
            map((responseData) => {
                this._htlService.helicopters = responseData.filter((h) => h.status !== 2);
                return responseData.filter((h) => h.status !== 2);
            }),
            catchError((errorRes) => {
                return throwError(errorRes);
            }),
        );
    }

    public getHelicopterAttributes(orgId: number) {
        let params = new HttpParams();
        params = params.append("organizationId", orgId.toString());
        return this._http.get<any>(environment.serverUrl + EndpointRoutes.GET_HELICOPTER_ATTRIBUTES, { params: params }).pipe(
            map((responseData) => {
                this._htlService.helicopterAttributes = responseData;
                return responseData;
            }),
            catchError((errorRes) => {
                return throwError(errorRes);
            }),
        );
    }

    public uploadHelicopterDocument(file: File, helicopterId: number): Observable<any> {
        const formData = new FormData();
        formData.append("helicopterId", helicopterId.toString());
        formData.append("filename", file.name);
        formData.append("file", file);
        return this._http.post<any>(environment.serverUrl + "helicopter/uploadDocument", formData).pipe(
            map((responseData) => {
                return responseData;
            }),
            catchError((errorRes) => {
                return throwError(errorRes);
            }),
        );
    }

    public deleteHelicopterDocument(documentId: number, helicopterId: number, filename: string): Observable<any> {
        let params = new HttpParams();
        params = params.append("documentId", documentId.toString());
        params = params.append("helicopterId", helicopterId.toString());
        params = params.append("filename", filename);
        return this._http.delete<any>(environment.serverUrl + "helicopter/deleteDocument", { params });
    }
}
